import { JsonStatReader as Reader } from '../node_modules/@lfi/jsonstat-js/dist/JsonStatReader.js';
import { array } from '../node_modules/@lfi/jsonstat-js/dist/array.js';

/**
 * Module to read NAFIDAS JSON-stat.
 * @module obj
 */
export class JsonStatReader extends Reader {

  /**
   * Render as a choropleth or proportional map?
   * @see NAFIDAS \scripts\php\class\Legacy\Product\MapData.php
   * @return {boolean}
   */
  isChoropleth () {
    let isChoropleth = false;
    const param = this.jsonStat.extension.parameter;
    if (param.Zielgroesse1.adTypGesha === '3') {
      isChoropleth = true;
    } else if (param.Zielgroesse2 && (param.Zielgroesse2.unit === 'ha' || param.Zielgroesse2.unit === param.Zielgroesse1.unit)) {
      isChoropleth = true;
    } else if (param.DiffProInv !== null && param.DiffProInv.id === '2') {
      isChoropleth = true;
    }

    return isChoropleth;
  }

  /**
   * Extract the values for the current data series.
   * @return {Array<Number>}
   * @private
   */
  extractSeries (rowIdx) {
    let valFromTo = array.rowToLinear(Number(rowIdx), this.shape);

    return this.jsonStat.value.slice(valFromTo[0], valFromTo[1]);
  }

  /**
   * Get the series items for the selected row ordered by value descending.
   * @return {DataSeries}
   * @param {Number} rowIdx
   */
  getDataSeries (rowIdx) {
    let data = {
      rowIdx: rowIdx,
      series: []
    };
    const geoId = this.getDimIdGeo(),
      geoIdx = this.getDimIndex(geoId),
      geoSize = this.shape[geoIdx];

    let series = this.extractSeries(rowIdx);
    series.forEach((value, i) => {
      if (i % this.getSizeOfMetric() === 0) {
        const catId = this.getCategoryIdByOffset(i, geoIdx);
        data.series.push({
          id: catId,
          label: this.getCategoryLabel(geoId, catId),
          value: value,
          error: series[i + 1]
        });
      }
    });
    data.total = geoSize > 1 ? data.series.pop() : data.series[0];
    data.series = this.#orderByValue(data.series);

    return data;
  }

  /**
   * Sort the array items in descending order by item value.
   * @param {Array<DataSeriesItem>} series items to sort
   * @return {Array} sorted items
   * @private
   */
  #orderByValue (series) {
    return series.sort((a, b) => b.value - a.value);
  }

  /**
   * Return the ID of the region variable.
   * Returns the ID (varNr) of the database variable regional demarcation.
   * @return {String}
   */
  getRegionId () {
    return this.jsonStat.extension.parameter.Aussageeinheit.id;
  }
}